import React from "react";
import "./ToolTipStyle.css";

const climateScoreColors = {
  1: "#75AC4A",
  2: "#9CA43E",
  3: "#B99E34",
  4: "#D9982C",
  5: "#FB9122",
};

const ToolTip = (props) => {
  if (props.active) {
    let score = props.payload[0].payload.climateAvg;
    let label = props.payload[0].payload.name;
    let color = props.payload[0].payload.color;
    return (
      <div className="customToolTip">
        <span className="toolTipRow">
          <div className="tinyCircle" style={{ backgroundColor: color }} />
          <h6 className="toolTipLabel">{label}</h6>
        </span>
        <div className="toolTipHr" />
        <span className="toolTipRow">
          <p className="toolTipText"> Average emission:</p>
          <div
            className="emissionsTag"
            style={{
              backgroundColor: climateScoreColors[Math.round(score)],
            }}
          >
            {" "}
            <p className="emissionCategoryRowText">{score}</p>
          </div>
        </span>
      </div>
    );
  } else {
    return null;
  }
};

export default ToolTip;
